import api from "./api";

export const getDigitalSignature = async (userId) => {
  const response = await api.get(`/api/v1/auth/users/${userId}/digital-signature`);
  return response.data;
};

export const getProfileImage = async (userId) => {
  const response = await api.get(`/api/v1/auth/users/${userId}/profile-image`);
  return response.data;
};

export const uploadProfileImage = async (userId, file) => {
  const formData = new FormData();
  formData.append("profileImage", file);

  const response = await api.post(
    `/api/v1/auth/users/${userId}/profile-image/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const saveProfileImageUrl = async (userId, url) => {
  const response = await api.put(
    `/api/v1/auth/users/${userId}/profile-image/url`,
    { url },
  );
  return response.data;
};

export const deleteProfileImage = async (userId) => {
  const response = await api.delete(
    `/api/v1/auth/users/${userId}/profile-image`,
  );
  return response.data;
};

export const uploadDigitalSignature = async (userId, file) => {
  const formData = new FormData();
  formData.append("signature", file);

  const response = await api.post(
    `/api/v1/auth/users/${userId}/digital-signature/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const saveDigitalSignatureUrl = async (userId, url) => {
  const response = await api.put(
    `/api/v1/auth/users/${userId}/digital-signature/url`,
    { url },
  );
  return response.data;
};

export const deleteDigitalSignature = async (userId) => {
  const response = await api.delete(
    `/api/v1/auth/users/${userId}/digital-signature`,
  );
  return response.data;
};
